import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=e5e625d0&scoped=true&"
import script from "./Sider.vue?vue&type=script&lang=js&"
export * from "./Sider.vue?vue&type=script&lang=js&"
import style0 from "./Sider.vue?vue&type=style&index=0&id=e5e625d0&prod&lang=scss&scoped=true&"
import style1 from "./Sider.vue?vue&type=style&index=1&id=e5e625d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e625d0",
  null
  
)

export default component.exports